import { IOccurrence } from "interfaces/Occurrence";
import { formatCurrency, formatDate } from "./formatters";
import { IReport } from "interfaces/Report";

function getReportSummaryString(report: IReport, index: number) {
  const isRegistered = report.policeman

  const registeredPolicemanData = report.policeman
  const detachedPolicemanData = report.superficialPoliceman

  return `
*------------ RELATORIO ${index + 1} ------------*

*--- DADOS DO PRONTA-RESPOSTA ---*
*PRONTA RESPOSTA:* ${isRegistered ? `${registeredPolicemanData.user.name} (REGISTRADO)` : `${detachedPolicemanData?.name} (AVULSO)`}
*CPF:* ${registeredPolicemanData?.user?.cpf || ""}
*RG:* ${registeredPolicemanData?.user?.rg || ""}
*E-MAIL:* ${registeredPolicemanData?.user?.email || ""}
*TEL:* ${registeredPolicemanData?.user?.contact?.phoneNumber.replace(/[^\d]/g, "") || ""}
*INICIO:* ${report?.createdAt ? formatDate(new Date(report?.createdAt)) : ""}
*HORARIO NO QTH:* ${report?.arrivalTime ? formatDate(new Date(report?.arrivalTime)) : ""
    }
*KM INICIAL:*
*KM FINAL:*
*KM ADICIONAL:* ${formatCurrency(
      Number(registeredPolicemanData?.vehicleValues?.additionalKm ?? 0)
    )}
*PEDÁGIO:* ${report?.tollValue ? formatCurrency(Number(report?.tollValue)) : ""}

*--- DADOS BANCARIOS DO PRONTA-RESPOSTA ---*
*BANCO:* ${registeredPolicemanData?.user?.bankAccount?.accountData.bank || ""}
*PIX:* ${registeredPolicemanData?.user?.bankAccount?.accountData.pix || ""}
*AGENCIA:* ${registeredPolicemanData?.user?.bankAccount?.accountData.agency || ""}
*CONTA:* ${registeredPolicemanData?.user?.bankAccount?.accountData.bank || ""}
*TIPO DE CONTA:* Conta corrente
`}


export function theftTemplate(occurrence: IOccurrence) {
  // template de furto
  const client = occurrence.client;
  const address = occurrence.occurrencesSuperficialAddresses.superficialAddress;
  const reports = occurrence.report;

  return `
*------------ DADOS DO CLIENTE ------------*

*CLIENTE:* ${client.name}
*SERVIÇO:* ACIONAMENTO VEÍCULAR
*ENDEREÇO:* ${address.street + `, ${address.number}`}
*CIDADE/ESTADO:* ${address.city + ` - ${address.uf}`}
*DATA DO ACIONAMENTO:* ${formatDate(new Date(occurrence.createdAt))}
*TÉRMINO:* ${occurrence.status === "concluido"
      ? formatDate(new Date(occurrence.updatedAt))
      : ""
    }

${reports?.map((report, index) => getReportSummaryString(report, index))}

*------------ DADOS DO PROTOCOLO ------------*

*PROTOCOLO:* ${occurrence.protocol ?? occurrence.id} - Gerado em: ${formatDate(new Date())}. por: ${occurrence.attendant.name
    }
  `;
}

export function stealTemplate(occurrence: IOccurrence) {
  // template de roubo
  const client = occurrence.client;
  const address = occurrence.occurrencesSuperficialAddresses.superficialAddress;
  const reports = occurrence.report;

  return `
*------------ DADOS DO CLIENTE ------------*

*CLIENTE:* ${client.name}
*SERVIÇO:* ROUBO VEÍCULAR - PLACA ${occurrence?.superficialVehicle?.plate || "Nao registrada"
    }
*ENDEREÇO:* ${address.street + ` - ${address.number}`}
*CIDADE/ESTADO:* ${address.city + `, ${address.uf}`}
*DATA DO ACIONAMENTO:* ${formatDate(new Date(occurrence.createdAt))}
*TÉRMINO:* ${occurrence.status === "concluido"
      ? formatDate(new Date(occurrence.updatedAt))
      : ""
    }
*KM INICIAL:*
*KM FINAL:*

${reports?.map((report, index) => getReportSummaryString(report, index))}

*------------ DADOS DO PROTOCOLO ------------*

*PROTOCOLO:* ${occurrence.protocol ?? occurrence.id} - Gerado em: ${formatDate(new Date())}. por: ${occurrence.attendant.name}`;
}

export function patrimonialTemplate(occurrence: IOccurrence) {
  // template patrimonial
  const client = occurrence.client;
  const address = occurrence.occurrencesSuperficialAddresses.superficialAddress;
  const reports = occurrence.report;

  return `
*------------ DADOS DO CLIENTE ------------*

*CLIENTE:* ${client?.name}
*SERVIÇO:* ACIONAMENTO PATRIMONIAL
*ENDEREÇO:* ${address?.street + `, ${address?.number}`}
*CIDADE/ESTADO:* ${address?.city + ` - ${address?.uf}`}
*DATA DO ACIONAMENTO:* ${formatDate(new Date(occurrence.createdAt))}
*TÉRMINO:* ${occurrence.status === "concluido"
      ? formatDate(new Date(occurrence.updatedAt))
      : ""
    }

${reports?.map((report, index) => getReportSummaryString(report, index))}

*------------ DADOS DO PROTOCOLO ------------*

*PROTOCOLO:* ${occurrence.protocol ?? occurrence.id} - Gerado em: ${formatDate(new Date())}. por: ${occurrence.attendant.name
    }
   `;
}
